/**
 * ViewHistoryManager
 *
 * Manages a navigation history stack for calendar view transitions.
 * Enables proper back-button behavior by tracking previous view states.
 *
 * Follows single responsibility: view navigation history only.
 */

import type { CalendarViewMode } from '@/components/calendar/CalendarSideDrawer';

export type ViewHistoryEntry = {
  viewMode: CalendarViewMode;
  date: string;
  isDayDrillDown: boolean;
};

export class ViewHistoryManager {
  private stack: ViewHistoryEntry[] = [];

  push(entry: ViewHistoryEntry): void {
    this.stack.push(entry);
  }

  pop(): ViewHistoryEntry | null {
    return this.stack.pop() ?? null;
  }

  peek(): ViewHistoryEntry | null {
    if (this.stack.length === 0) return null;
    return this.stack[this.stack.length - 1];
  }

  clear(): void {
    this.stack = [];
  }

  get isEmpty(): boolean {
    return this.stack.length === 0;
  }
}
